/** @format */

import { dangerColor, defaultFont, grayColor, primaryColor, successColor, whiteColor } from '../../../../jss/material-dashboard-pro-react';
import COLORS from '../../colors';

const InputStyle = {
    disabled: {
        '&:before': {
            borderColor: 'transparent !important',
        },
    },
    underline: {
        '&:hover:not($disabled):before,&:before': {
            borderBottom: `2px solid ${COLORS.DARK_FUNCTION.FUNCTION_4}`,
        },
        '&:after': {
            borderColor: COLORS.MAIN.PRIMARY,
        },
    },
    underlineError: {
        '&:after': {
            borderColor: COLORS.FUNCTION.DANGER,
        },
    },
    underlineSuccess: {
        '&:after': {
            borderColor: COLORS.FUNCTION.SUCCESS,
        },
    },
    labelRoot: {
        fontSize: '14px',
        paddingLeft: 15,
        color: COLORS.MAIN.DARK + ' !important',
        top: '10px',
        '& + $underline': {
            marginTop: '0px',
        },
        fontFamily: '"Helvetica 55 Roman"',
        transform: 'translate(0, 1.5px) scale(0.75)',
        transformOrigin: 'top left',
    },
    labelRootError: {
        color: COLORS.FUNCTION.DANGER + ' !important',
    },
    labelRootSuccess: {
        color: COLORS.FUNCTION.SUCCESS + ' !important',
    },
    labelRootColor: {
        color: COLORS.MAIN.DARK + ' !important',
        fontWeight: 'bold',
    },
    labelRootPadding: {
        paddingLeft: 15,
    },
    datePicker: {
        marginBottom: 25,
        backgroundColor: '#F5F5F5',
    },
    formControl: {
        margin: '0 0 17px 0',
        paddingTop: '25px',
        letterSpacing: 0.8,
        position: 'relative',
        verticalAlign: 'unset',
        '& svg,& .fab,& .far,& .fal,& .fas,& .material-icons': {
            color: COLORS.MAIN.DARK,
        },
        backgroundColor: '#F5F5F5',
        fontWeight: 'bold',
    },
    input: {
        paddingLeft: 15,
        color: COLORS.MAIN.DARK,
        '&,&::placeholder': {
            fontWeight: 'bold',
            lineHeight: '1.42857',
            opacity: '1',
        },
        '&::placeholder': {
            color: COLORS.MAIN.DARK,
        },
    },
    datePickerInput: {
        float: 'none',
        boxShadow: 'none',
        backgroundColor: 'transparent',
        borderRadius: 0,
        fontWeight: 800,
        width: '100%',
        height: 36,
        padding: '7px 0',
        fontSize: 15,
        lineHeight: 1.428571429,
        display: 'block',
        color: COLORS.MAIN.DARK,
        paddingLeft: 10,
        border: 'none',
        borderBottom: `2px solid ${COLORS.DARK_FUNCTION.FUNCTION_4}`,
    },
};

export default InputStyle;
